/**
 * 二级练习相关的打点上报
 */

export default {
  /**
   * 视频详情页内点击
   * @param {String} click 点击
   * @param {String} type 视频详情页展示的教程ID
   */
  ncreSkillvideoClick({ click, type }) {
    this.collect('ncre_skillvideo_click', { click, type });
  },

  /**
   * 视频详情页内展示
   * @param {String} show 展示内容
   * @param {Stirng} type 教程ID
   */
  ncreSkillvideoShow({ show, type }) {
    this.collect('ncre_skillvideo_show', { show, type });
  },
};
